import { render, staticRenderFns } from "./TableFiles.vue?vue&type=template&id=215a9b40&scoped=true"
import script from "./TableFiles.ts?vue&type=script&lang=ts&external"
export * from "./TableFiles.ts?vue&type=script&lang=ts&external"
import style0 from "./TableFiles.vue?vue&type=style&index=0&id=215a9b40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a9b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('215a9b40')) {
      api.createRecord('215a9b40', component.options)
    } else {
      api.reload('215a9b40', component.options)
    }
    module.hot.accept("./TableFiles.vue?vue&type=template&id=215a9b40&scoped=true", function () {
      api.rerender('215a9b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/details/DocumentsTab/TableFiles/TableFiles.vue"
export default component.exports